import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import DashboardSection from "../components/DashboardSection";
import OrderStatusBadge from "../components/OrderStatusBadge";

function money(value) {
  const amount = Number(value || 0);
  return `$${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function dateText(value) {
  if (!value) return "Not scheduled";
  const date = new Date(`${value}T12:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

function RecentOrders({ orders }) {
  const navigate = useNavigate();
  const rows = orders || [];
  return (
    <DashboardSection
      title="Recent Orders"
      description="The latest customer orders placed through the website."
      action={<button type="button" className="admin-link-button" onClick={() => navigate("/admin/orders")}>View all orders<ArrowRight size={16} /></button>}
    >
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead><tr><th>Order</th><th>Customer</th><th>Items</th><th>Delivery</th><th>Total</th><th>Status</th></tr></thead>
          <tbody>
            {rows.length ? rows.map((order) => (
              <tr key={order.id}>
                <td><button type="button" className="admin-table__order-link" onClick={() => navigate(order.path)}>#{order.orderNumber}</button></td>
                <td><strong>{order.customer}</strong></td>
                <td>{order.items}</td>
                <td><div className="admin-table__stacked-cell"><strong>{dateText(order.date)}</strong><span>{order.deliveryTime}</span></div></td>
                <td><strong>{money(order.total)}</strong></td>
                <td><OrderStatusBadge status={order.status} label={order.statusLabel} /></td>
              </tr>
            )) : <tr><td colSpan="6"><p className="admin-dashboard-empty">No orders yet.</p></td></tr>}
          </tbody>
        </table>
      </div>
    </DashboardSection>
  );
}

export default RecentOrders;
